/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostUserQuestionRequest
 */
export interface PostUserQuestionRequest {
    /**
     * 
     * @type {string}
     * @memberof PostUserQuestionRequest
     */
    answererId: string;
    /**
     * 
     * @type {string}
     * @memberof PostUserQuestionRequest
     */
    title: string;
}

/**
 * Check if a given object implements the PostUserQuestionRequest interface.
 */
export function instanceOfPostUserQuestionRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "answererId" in value;
    isInstance = isInstance && "title" in value;

    return isInstance;
}

export function PostUserQuestionRequestFromJSON(json: any): PostUserQuestionRequest {
    return PostUserQuestionRequestFromJSONTyped(json, false);
}

export function PostUserQuestionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostUserQuestionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'answererId': json['answererId'],
        'title': json['title'],
    };
}

export function PostUserQuestionRequestToJSON(value?: PostUserQuestionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'answererId': value.answererId,
        'title': value.title,
    };
}

